<template>
<div class="card">
    <div class="card-header">Pre Offer Review</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>
        <BaseStatusHelp lifecycleStatus="16"/>

        <b-form @submit.stop.prevent="onSubmit">
            <b-row>
                <b-col>
                    <LifecycleCheckList lifecycleStatus="16" :requestId="request.id"
                        v-on:checklist-update="updateChecklistStatus($event)" ref="checklist"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <BaseParagraphInput v-model="request.preofferComments"
                        :v="$v.request.preofferComments" 
                        slug="preOfferComments"
                        label="Internal Comments"/>
                </b-col>
            </b-row>
                        
            <div>
            <b-button type="submit" variant="primary">Complete Pre Offer Review</b-button>
            <b-button type="button" variant="outline-primary" @click="save">Save</b-button>
            </div>
        </b-form>
    </div>
</div>

</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, numeric } from 'vuelidate/lib/validators'
import LifecycleCheckList from '@/components/lifecycles/LifecycleCheckList'

export default {
    components: {
        LifecycleCheckList,
    },
    props: {
        request: Object
    },
    data() {
        return { 
            checklistComplete: false,
            comments: '',
            repost: false,
            saveOnly: false,
        }
    },
            
    mounted: function() {
        this.autosave()
    },
    
    beforeDestroy() {
       clearInterval(this.autosave_id)
    },
    
     validations: {
         comments: { required: false, maxLength: maxLength(4000) },
         checklistComplete: { checked: value => value === true },
         request: { 
             preofferComments: { required: false, maxLength: maxLength(4000) }
         }
     },
    
    methods: {
        updateChecklistStatus(b) {
            this.checklistComplete = b
        },

        autosave() {          
            this.autosave_id = setInterval(() => {
                this.save()
            }, 300000);
        },

        save() {
            this.saveOnly = true
            this.onSubmit()
            this.saveOnly = false
        },

        onSubmit() {
            if (!this.saveOnly) {
                this.$refs.checklist.emitCheckListStatus()
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$nextTick(() => {
                        document.getElementById('form-container').scrollIntoView()
                    })
                    return
                }
            }

            let payload = {
                requestId: this.request.id,
                comments: this.request.preofferComments,
                advanceNextLifecycle: !this.saveOnly,
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/preofferReview`, payload)
                  .then(response => {                       
                    this.showRootToast("HRM Request Has Been Updated", "Success", "success")
                    if (payload.advanceNextLifecycle === true) {
                        this.$router.push('/home')
                    } 
                  })
                  
        },
        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })

        },
    }   
}
</script>